import React, { Component } from 'react'
import Paper from '@material-ui/core/Paper'
import NavigationAppShell from '../../common/navigation-app-shell'
import SimcardsTable from './containers/simcards-table'
import EditSimcardDialog from './containers/edit-simcard-dialog'
import NewSimcardDialog from './containers/new-simcard-dialog'

class SimcardsPage extends Component {
  render () {
    return (
      <NavigationAppShell
        content={
          <Paper>
            <SimcardsTable />
            <EditSimcardDialog />
            <NewSimcardDialog />
          </Paper>
        }
        pageName={'Simcards'}
      />
    )
  }
}

export default SimcardsPage



// WEBPACK FOOTER //
// ./src/pages/simcards/index.js